<div class="login-container">
    <app-exam-header [pageTitle]="'Login'"></app-exam-header>
    <div class="login-content-wrapper">
        <div class="login-row">
            <!-- Left side - Image section -->
            <div class="login-image-section">
                <div class="image-content">
                    <img src="../../../../assets/images/login.png" alt="Profile Illustration">
                </div>
            </div>
            
            <!-- Right side - Login form section -->
            <div class="login-form-section">
                <div class="login-form-wrapper">
                    <div class="login-form-header">
                        <h2>Forgot Password</h2>
                        <p>Enter your email to reset your password</p>
                    </div>
                    
                    <form [formGroup]="loginForm">
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>Email</mat-label>
                                <mat-icon matPrefix>person</mat-icon>
                                <input matInput formControlName="username" autocomplete="off">
                                <mat-error *ngIf="loginForm.get('username').hasError('required')">
                                    Username is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        
                        
                        <div class="form-actions">
                            <button class="login-btn" (click)="SFLogin()">
                                <span>Send Mail</span>
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                        <div class="form-footer">
                            <p>Don have an account? <a routerLink="/login">Login</a></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <app-exam-footer class="footer"></app-exam-footer>
</div>